export enum ExternalStockSourceType {
    Dealer = "Dealer",
    Vendor = "Vendor",
}
